import bonitoMS from './bonito-ms.jpg';
import itacareBA from './itacare-ba.jpg';
import ubatubaSP from './ubatuba-sp.jpg';
import arraialDoCaboRJ from './arraial-do-cabo-rj.jpg';
import aquirazCE from './aquiraz-ce.jpg';
import praiaDePipaRN from './praia-de-pipa-rn.jpg';
import aracajuSE from './aracaju-se.jpg';
import florianopolisSC from './florianopolis-sc.jpg';
import beloHorizonteMG from './belo-horizonte-mg.jpg';
import recifePE from './recife-pe.jpg';
import salvadorBA from './salvador-ba.jpg';
import saoLuisMA from './sao-luis-ma.jpg';
import rioDeJaneiroRJ from './rio-de-janeiro-rj.jpg';
import goianiaGO from './goiania-go.jpg';
import saoPauloSP from './sao-paulo-sp.jpg';
import balnearioCamboriuSC from './balneario-camboriu-sc.jpg';
import curitibaPR from './curitiba-pr.jpg';
import ouroPretoMG from './ouro-preto-mg.jpg';
import petropolisRJ from './petropolis-rj.jpg';
import olindaPE from './olinda-pe.jpg';
import arraialAjudaBA from './arraial-ajuda-ba.jpg';
import gramadoRS from './gramado-rs.jpg';
import canelaRS from './canela-rs.jpg';
import paratyRJ from './paraty-rj.jpg';
import itatiaiaRJ from './itatiaia-rj.jpg';
import cambaraDoSulRS from './cambara-do-sul-rs.jpg';
import marauBA from './marau-ba.jpg';
import tamandarePE from './tamandare-pe.jpg';
import portoAlegreRS from './porto-alegre-rs.jpg';
import brasiliaDF from './brasilia-df.jpg';
import belemPA from './belem-pa.jpg';
import fozDoIguacuPR from './foz-do-iguacu-pr.jpg';
import tiradentesMG from './tiradentes-mg.jpg';
import olimpiaSP from './olimpia-sp.jpg';
import jericoacoaraCE from './jericoacoara-ce.jpg';
import ilheusBA from './ilheus-ba.jpg';
import maragogiAL from './maragogi-al.jpg';
import campinasSP from './campinas-sp.jpg';
import camposDoJordaoSP from './campos-do-jordao-sp.jpg';
import pirenopolisGO from './pirenopolis-go.jpg';
import penhaSC from './penha-sc.jpg';
import rioQuenteGO from './rio-quente-go.jpg';
import chapadaDosGuimaraesMT from './chapada-dos-guimaraes-mt.jpg';
import alterDoChaoPA from './alter-do-chao-pa.jpg';
import socorroSP from './socorro-sp.jpg';
import portoDeGalinhasPE from './porto-de-galinhas-pe.jpg';
import guarapariES from './guarapari-es.jpg';
import fernandoDeNoronhaPE from './fernando-de-noronha-pe.jpg';
import joaoPessoaPB from './joao-pessoa-pb.jpg';
import natalRN from './natal-rn.jpg';
import portoSeguroBA from './porto-seguro-ba.jpg';
import ilhabelaSP from './ilhabela-sp.jpg';
import manausAM from './manaus-am.jpg';
import barraDeSaoMiguelAL from './barra-de-sao-miguel-al.jpg';
import fortalezaCE from './fortaleza-ce.jpg';
import vitoriaES from './vitória-es.jpg';
import monteVerdeMG from './monte-verde-mg.jpg';
import parnaibaPI from './parnaiba-pi.jpg';
import teresopolisRJ from './teresopolis-rj.jpg';
import caboDeSantoAgostinhoPE from './cabo-de-santo-agostinho-pe.jpg';
import maceioAL from './maceio-al.jpg';
import campoGrandeMS from './campo-grande-ms.jpg';
import imbassaiBA from './imbassaiBA.jpg';

export const ALL_TIPS = {
  bonitoMS,
  itacareBA,
  ubatubaSP,
  arraialDoCaboRJ,
  aquirazCE,
  praiaDePipaRN,
  aracajuSE,
  florianopolisSC,
  beloHorizonteMG,
  recifePE,
  salvadorBA,
  saoLuisMA,
  rioDeJaneiroRJ,
  goianiaGO,
  saoPauloSP,
  balnearioCamboriuSC,
  curitibaPR,
  ouroPretoMG,
  petropolisRJ,
  olindaPE,
  arraialAjudaBA,
  gramadoRS,
  canelaRS,
  paratyRJ,
  itatiaiaRJ,
  cambaraDoSulRS,
  marauBA,
  tamandarePE,
  portoAlegreRS,
  brasiliaDF,
  belemPA,
  fozDoIguacuPR,
  tiradentesMG,
  olimpiaSP,
  jericoacoaraCE,
  ilheusBA,
  maragogiAL,
  campinasSP,
  camposDoJordaoSP,
  pirenopolisGO,
  penhaSC,
  rioQuenteGO,
  chapadaDosGuimaraesMT,
  alterDoChaoPA,
  socorroSP,
  portoDeGalinhasPE,
  guarapariES,
  fernandoDeNoronhaPE,
  joaoPessoaPB,
  natalRN,
  portoSeguroBA,
  ilhabelaSP,
  manausAM,
  barraDeSaoMiguelAL,
  fortalezaCE,
  vitoriaES,
  monteVerdeMG,
  parnaibaPI,
  teresopolisRJ,
  caboDeSantoAgostinhoPE,
  maceioAL,
  campoGrandeMS,
  imbassaiBA,
};
